import {
  faCircleCheck,
  faCircleExclamation,
  faCircleQuestion,
  faTimes,
  IconDefinition
} from "@fortawesome/free-solid-svg-icons"
import type { PreventionMeasuresView } from "./prevention-action.utils"

// Shared dashed ring, including in FontAwesome-only navigation components.
// Passed directly to FontAwesomeIcon, never registered in the global icon library.
const dashedCircle: IconDefinition = {
  prefix: "fas",
  iconName: "circle",
  icon: [
    28,
    28,
    [],
    "",
    [
      "M 14.000 0.000 A 14 14 0 0 1 18.788 0.844 L 18.104 2.724 A 12 12 0 0 0 14.000 2.000 Z",
      "M 21.000 1.876 A 14 14 0 0 1 24.725 5.001 L 23.193 6.287 A 12 12 0 0 0 20.000 3.608 Z",
      "M 26.124 7.000 A 14 14 0 0 1 27.787 11.569 L 25.818 11.916 A 12 12 0 0 0 24.392 8.000 Z",
      "M 28.000 14.000 A 14 14 0 0 1 27.156 18.788 L 25.276 18.104 A 12 12 0 0 0 26.000 14.000 Z",
      "M 26.124 21.000 A 14 14 0 0 1 22.999 24.725 L 21.713 23.193 A 12 12 0 0 0 24.392 20.000 Z",
      "M 21.000 26.124 A 14 14 0 0 1 16.431 27.787 L 16.084 25.818 A 12 12 0 0 0 20.000 24.392 Z",
      "M 14.000 28.000 A 14 14 0 0 1 9.212 27.156 L 9.896 25.276 A 12 12 0 0 0 14.000 26.000 Z",
      "M 7.000 26.124 A 14 14 0 0 1 3.275 22.999 L 4.807 21.713 A 12 12 0 0 0 8.000 24.392 Z",
      "M 1.876 21.000 A 14 14 0 0 1 0.213 16.431 L 2.182 16.084 A 12 12 0 0 0 3.608 20.000 Z",
      "M 0.000 14.000 A 14 14 0 0 1 0.844 9.212 L 2.724 9.896 A 12 12 0 0 0 2.000 14.000 Z",
      "M 1.876 7.000 A 14 14 0 0 1 5.001 3.275 L 6.287 4.807 A 12 12 0 0 0 3.608 8.000 Z",
      "M 7.000 1.876 A 14 14 0 0 1 11.569 0.213 L 11.916 2.182 A 12 12 0 0 0 8.000 3.608 Z"
    ].join(" ")
  ]
}

export const PREVENTION_MEASURE_ICONS: Record<PreventionMeasuresView, IconDefinition> = {
  "in-place": faCircleCheck,
  planned: dashedCircle,
  "to-plan": faCircleQuestion,
  overdue: faCircleExclamation,
  missing: faTimes
}
